module.exports = __webpack_public_path__ + "img/compliance.7e76b12b.png";